import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import AnimatedSection from '../components/AnimatedSection';
import PageHeader from '../components/PageHeader';
import SEO from '../components/SEO';
import './JurusanPage.css';

const JurusanPage = () => {
  const [majors, setMajors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMajors = async () => {
      setLoading(true);
      try {
        const majorsQuery = query(collection(db, 'majors'), orderBy('order', 'asc'));
        const majorsSnapshot = await getDocs(majorsQuery);
        const majorsData = majorsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setMajors(majorsData);
      } catch (err) {
        console.error("Error fetching majors data:", err);
        setError("Gagal memuat data program keahlian. Silakan coba lagi nanti.");
      } finally {
        setLoading(false);
      }
    };

    fetchMajors();
  }, []);

  return (
    <>
      <SEO
        title="Program Keahlian - SMK Pariwisata Sumbangsih"
        description="Daftar program keahlian unggulan di SMK Pariwisata Sumbangsih: Perhotelan dan Usaha Perjalanan Wisata (UPW)."
      />
      <PageHeader
        title="Program Keahlian"
        subtitle="Temukan program keahlian yang sesuai dengan minat dan bakat Anda di SMK Pariwisata Sumbangsih."
      />
      <AnimatedSection>
        <section className="section">
          <div className="container">
            <div className="jurusan-list-grid">
              {loading ? (
                // Skeleton Loader
                Array.from({ length: 2 }).map((_, index) => (
                  <div key={index} className="jurusan-list-card skeleton">
                    <div className="jurusan-list-image-wrapper"></div>
                    <div className="jurusan-list-content"></div>
                  </div>
                ))
              ) : error ? (
                <p className="error-message">{error}</p>
              ) : (
                majors.map((jurusan) => (
                  <Link to={`/jurusan/${jurusan.id}`} key={jurusan.id} className="jurusan-list-card">
                    <div className="jurusan-list-image-wrapper">
                      <img src={jurusan.image} alt={jurusan.title} className="jurusan-list-image" />
                    </div>
                    <div className="jurusan-list-content">
                      <h3>{jurusan.title}</h3>
                      <p style={{ textAlign: 'justify' }}>{jurusan.description}</p>
                      <span className="jurusan-list-link">Lihat Detail &rarr;</span>
                    </div>
                  </Link>
                ))
              )}
            </div>
          </div>
        </section>
      </AnimatedSection>
    </>
  );
};

export default JurusanPage;